// extracted by mini-css-extract-plugin
module.exports = {"INPUT_HEIGHT":"45px","main-gray":"#b4b4b4","wrapper":"Select-module__wrapper___2m0tn","select":"Select-module__select___1h13X"};